export default function(products) {
  let object = {}
  products.map(product => {
    object[product.productCode] = product.description
    return null
  })
  return object
}



// WEBPACK FOOTER //
// ./src/App/helpers/SecuritySatProducts/getDescription.js